import { Type } from '@sinclair/typebox';
export const POOL_PERIODS = ['5M', '1H', '6H', '1D', 'ALL'];
export const PoolPeriodSchema = Type.Union([
    Type.Literal('5M'),
    Type.Literal('1H'),
    Type.Literal('6H'),
    Type.Literal('1D'),
    Type.Literal('ALL'),
]);
export const POOL_PERIOD_MINUTES_MAP = {
    '5M': 5,
    '1H': 60,
    '6H': 360,
    '1D': 1440,
};
//# sourceMappingURL=pool-period.js.map